'use client';

import type { RefObject } from 'react';
import React, { cloneElement } from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './Fade.module.scss';
type Props = {
  children: React.ReactElement;
  durationEnter?: number;
  durationExit?: number;
  isActive?: boolean;
  nodeRef: RefObject<any>;
};
export const Fade = ({
  children,
  durationEnter = 250,
  durationExit = 100,
  isActive,
  nodeRef
}: Props) => {
  const childrenWithVars = cloneElement(children, {
    ...children.props,
    style: {
      ...children.props.style,
      '--fade-enter-duration': durationEnter + 'ms',
      '--fade-exit-duration': durationExit + 'ms'
    }
  });
  return <CSSTransition classNames={{
    enter: styles.enter,
    enterActive: styles.enterActive,
    exit: styles.exit,
    exitActive: styles.exitActive
  }} in={Boolean(isActive)} nodeRef={nodeRef} timeout={{
    enter: durationEnter,
    exit: durationExit
  }} unmountOnExit data-sentry-element="CSSTransition" data-sentry-component="Fade" data-sentry-source-file="Fade.tsx">
      {childrenWithVars}
    </CSSTransition>;
};